<template>
  <p
    class="text-caption-1 rounded-lg px-2 py-1.5"
    :class="dark ? 'bg-dm-80 text-white' : 'border border-dm-20 bg-dm-10'"
  >
    {{ label }}
  </p>
</template>

<script setup lang="ts">
type Props = {
  label: string
  dark?: boolean
}
defineProps<Props>()
</script>

<style scoped></style>
